import Color from '@components/Color';
import React from 'react';
import Row from './Row';

type Props = {
	label: string;
	hex: string;
	onChange: (hex: string) => void;
	// eslint-disable-next-line react/require-default-props
	disableAlpha?: boolean;
};

export default ({ label, hex, onChange, disableAlpha }: Props) => (
	<Row label={label}>
		<Color
			color={hex}
			onChange={onChange}
			data-testid={`color-${label}`}
			disableAlpha={disableAlpha}
		/>
	</Row>
);
